import { type UseNavigateResult } from "@tanstack/react-router";
import { type Cache } from "@urql/exchange-graphcache";
import { Howl } from "howler";

import IncidentsStartedSfx from "@/assets/sounds/guardme-started.mp3";
import { type DocumentType } from "@/gql";
import { GraphqlCheckInEvent } from "@/gql/graphql";
import { toast } from "@/lib/toast";

import { CHECK_IN_UPDATES_SUBSCRIPTION } from "../graphql/check-in-updates-subscription";

export function checkinUpdatesResolver(navigate: UseNavigateResult<string>) {
  return (
    result: DocumentType<typeof CHECK_IN_UPDATES_SUBSCRIPTION>,
    _args: never,
    cache: Cache,
  ) => {
    if (!result?.checkInUpdates?.checkIn) {
      // no incidents on object, do nothing
      return;
    }

    const event = result.checkInUpdates.event ?? "updated";
    const id = result.checkInUpdates.checkIn.id;
    const organizationId = result.checkInUpdates.checkIn.organizationId;

    if (event === GraphqlCheckInEvent.New) {
      const sound = new Howl({
        src: IncidentsStartedSfx,
      });

      const soundId = sound.play();

      toast.info(`New Check In (${result.checkInUpdates.checkIn.shortId})`, {
        action: {
          label: "View",
          onClick: () => {
            navigate({
              params: {
                orgId: organizationId,
                id: id,
              },
              to: "/$orgId/check-in/$id",
            });
          },
        },
        description: `${
          result.checkInUpdates.checkIn.member?.displayName ??
          result.checkInUpdates.checkIn.member?.fullName
        } check in`,
      });

      setTimeout(() => {
        sound.stop(soundId);
      }, 3_000);
    }

    // invalidate incident query results to cause refetch with new data
    for (const field of cache
      .inspectFields("Query")
      .filter((query) => query.fieldName === "checkIns")) {
      cache.invalidate("Query", "checkIns", field.arguments);
    }
  };
}
